// 운영관리 공유 타입 + 상태값 정의 (업체 → 사이트 → 이슈)

export const CONTRACT_STATUSES = ['상담', '진행중', '종료(취소)', '계약완료'] as const;
export const DEPOSIT_STATUSES = ['미입금', '계약금입금', '입금완료', '취소'] as const;
export const BUILD_STATUSES = ['미진행상태', '진행중(테스트)', '구축완료', '서비스중', '취소'] as const;
export const SUBSCRIPTION_STATUSES = ['미입금', '일부입금', '계약취소', '입금완료'] as const;
export const ISSUE_STATUSES = [
  '오류발생',
  '오류수정중',
  '패치중',
  '패치완료',
  '개선요청',
  '개선진행중',
  '개선완료',
  '개선취소',
] as const;

export const SERVICE_BUILD_STATUS = '서비스중';

export interface Company {
  id: number;
  name: string;
  contact: string; // 담당자 연락처
  memo: string;
  contractAmount: number; // 계약금액(원)
  contractStatus: string;
  depositStatus: string;
  createdAt: string;
  updatedAt: string;
  siteCount: number;
}

export interface Site {
  id: number;
  companyId: number;
  companyName?: string;
  name: string;
  url: string;
  buildStatus: string;
  subscriptionStatus: string;
  createdAt: string;
  updatedAt: string;
  issueCount: number;
}

export interface Issue {
  id: number;
  siteId: number;
  title: string;
  content: string;
  issueStatus: string;
  createdAt: string;
  updatedAt: string;
}

export type CompanyInput = {
  name: string;
  contact?: string;
  memo?: string;
  contractAmount?: number;
  contractStatus?: string;
  depositStatus?: string;
};
export type SiteInput = {
  companyId: number;
  name: string;
  url?: string;
  buildStatus?: string;
  subscriptionStatus?: string;
};
export type IssueInput = {
  siteId: number;
  title: string;
  content?: string;
  issueStatus?: string;
};
